const formTextarea = document.querySelectorAll('.form-field-textarea')

function checkInputStatus(inputField, input) {

  const valueSize = input.value.length

  if(valueSize > 0) {
    inputField.classList.add('input-focus')
  } else {
    inputField.classList.remove('input-focus')
  }

}

formTextarea.forEach((inputField) => {

  const input = inputField.querySelector('textarea')

  if(!input) return;

  input.addEventListener('focus', function () {
    inputField.classList.add('input-focus')
  })

  input.addEventListener('focusout', function () {
    checkInputStatus(inputField, input)
  })

  input.addEventListener('keyup', () => {
    checkInputStatus(inputField, input)
  })

})
